import { render, staticRenderFns } from "./PromotionDappRewardItem.vue?vue&type=template&id=d1d42ad0&scoped=true&"
import script from "./PromotionDappRewardItem.vue?vue&type=script&lang=js&"
export * from "./PromotionDappRewardItem.vue?vue&type=script&lang=js&"
import style0 from "./PromotionDappRewardItem.vue?vue&type=style&index=0&id=d1d42ad0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d42ad0",
  null
  
)

export default component.exports